import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../../services/auth.service';
import { UserService } from '../../../services/user.service';
import { ToastService } from '../../../services/toast.service';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss'],
})
export class RegisterComponent implements OnInit {
  name: string = '';
  email: string = '';
  mobile_no: string = '';
  country: any = null;
  country_name: string = '';
  password: string = '';
  showPassword: boolean = false;
  countryOptions: any[] = [];
  registration_form_filled: boolean = false;
  
  // Add these validation properties
  isSubmitting: boolean = false;
  validationErrors: any = {};

  ngOnInit(): void {
    this.userService.getCountries().subscribe((data) => {
      this.countryOptions = data;
    });
  }

  constructor(
    private authService: AuthService,
    private userService: UserService,
    private toaster: ToastService,
    private router: Router
  ) {}

  // Add validation method
  validateForm(): boolean {
    this.validationErrors = {}; // Clear previous errors
    
    if (!this.name || this.name.trim().length === 0) {
      this.validationErrors.name = 'Name is required';
    } else if (this.name.length < 3) {
      this.validationErrors.name = 'Name must be at least 3 characters long';
    }
    
    if (!this.email || this.email.trim().length === 0) {
      this.validationErrors.email = 'Email is required';
    } else if (!this.isValidEmail(this.email)) {
      this.validationErrors.email = 'Please enter a valid email';
    }
    
    if (!this.country) {
      this.validationErrors.country = 'Please select a country';
    }
    
    if (!this.mobile_no || this.mobile_no.trim().length === 0) {
      this.validationErrors.mobile = 'Mobile number is required';
    } else if (this.country && this.mobile_no.length !== this.country.mobile_number_length) {
      this.validationErrors.mobile = `Mobile number must be ${this.country.mobile_number_length} digits`;
    }
    
    if (!this.password || this.password.length < 8) {
      this.validationErrors.password = 'Password must be at least 8 characters';
    }
    
    return Object.keys(this.validationErrors).length === 0;
  }

  // Add email validation helper
  isValidEmail(email: string): boolean {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  register(): void {
    // Clear previous errors and validate
    if (!this.validateForm()) {
      const firstError = Object.values(this.validationErrors)[0];
      this.toaster.showToast(firstError as string, 'error');
      return;
    }

    this.isSubmitting = true;
    const fullMobileNumber = `${this.country.country_code}${this.mobile_no}`;
    const userData = {
      name: this.name.trim(),
      email: this.email.toLowerCase().trim(),
      mobile_no: fullMobileNumber,
      country_name: this.country.name, // Use country.name instead of country_name
      password: this.password,
    };

    this.authService.register(userData).subscribe({
      next: (response) => {
        this.registration_form_filled = true;
        this.toaster.showToast('OTP has been sent to your E-mail', 'success');
        this.isSubmitting = false;
      },
      error: (error) => {
        this.isSubmitting = false;
        
        // Handle specific error messages
        let errorMessage = 'Oh uh! Something went wrong!';
        
        if (error?.error?.message) {
          errorMessage = error.error.message;
        } else if (error?.error?.error) {
          errorMessage = error.error.error;
        }
        
        // Only show "Email already exists" if it's actually from server
        if (errorMessage.toLowerCase().includes('email') && errorMessage.toLowerCase().includes('exist')) {
          this.validationErrors.email = errorMessage;
        }
        
        this.toaster.showToast(errorMessage, 'error');
        console.error('Error registering', error);
      },
    });
  }

  // Add helper method to check if field has error
  hasError(field: string): boolean {
    return !!this.validationErrors[field];
  }


  navigateToLogin(): void {
    this.router.navigate(['/auth']);
  }

  togglePasswordVisibility(passwordInput: HTMLInputElement): void {
    this.showPassword = !this.showPassword;
    passwordInput.type = this.showPassword ? 'text' : 'password';
  }
}